import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import PasswordCriteria, { isStrongPassword } from "../components/PasswordCriteria";
import { resetPassword } from "../api/auth.api";
import { useTranslation } from "react-i18next";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  const token = params.get("token");

  const [password, setPassword] = useState("");
  const [status, setStatus] = useState("idle"); // idle | loading | success | error
  const [errorKey, setErrorKey] = useState("error");
  const { t } = useTranslation();

  const passwordValid = isStrongPassword(password);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!token) {
      setErrorKey("errorTokenInvalid");
      setStatus("error");
      return;
    }

    // Clientseitige Prüfung: verhindert einen Serverabruf bei schwachem Passwort
    if (!passwordValid) {
      setErrorKey("errorWeakPassword");
      setStatus("error");
      return;
    }

    setStatus("loading");

    try {
      await resetPassword(token, password);
      setStatus("success");
      setTimeout(() => navigate("/login"), 1500);
    } catch (err) {
      if (err?.code === "WEAK_PASSWORD") {
        setErrorKey("errorWeakPassword");
      } else if (err?.code === "INVALID_OR_EXPIRED_TOKEN") {
        setErrorKey("errorTokenInvalid");
      } else {
        setErrorKey("error");
      }
      setStatus("error");
    }
  };

  if (!token) {
    return <p className="reset-error-message" style={{ color: "red" }}>{t("auth.resetPassword.missingToken")}</p>;
  }

  return (
    <div className="content">
    <Header />
    <div>
      {status === "success" ? (
        <div style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "60vh",
          fontSize: "18px"
        }}>
          <p>{t("auth.resetPassword.success")}</p>
        </div>
      ) : (
        <form className="login-form" onSubmit={handleSubmit}>
          <h2 className="login-headline">{t("auth.resetPassword.title")}</h2>
          <input
            data-testid="reset-password"
            placeholder={t("auth.resetPassword.passwordPlaceholder")}
            type="password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              if (status === "error") setStatus("idle");
            }}
          />

          <PasswordCriteria password={password} />

          <button
            className="form-button"
            type="submit"
            disabled={status === "loading" || !passwordValid}
          >
            {status === "loading" ? t("auth.resetPassword.loading") : t("auth.resetPassword.submit")}
          </button>
        </form>
      )}

      {status === "error" && (
        <p style={{ color: "red", textAlign: "center", padding: "0 20px" }}>
          {t(`auth.resetPassword.${errorKey}`)}
        </p>
      )}
    </div>
    <Footer />
    </div>
  );
}